"use client";
import { FrequencyType, PlanType } from '@/utils/type/price';
import { SerializedEditorState } from "@payloadcms/richtext-lexical/lexical";
import dynamic from "next/dynamic";
import { ReactNode } from "react";
const PriceBlockCoursesV2 = dynamic(
  () => import("@/components/Price/PriceBlockV2"),
  { ssr: false },
);
type FrequenciesType = {
  value: FrequencyType;
  label: string;
  priceSuffix: string;
  individualPriceSuffix: string;
  discount?: string;
};

interface PriceBlockCoursesProps {
  id?: string;
  title?: ReactNode | SerializedEditorState;
  selectPackageLabel?: string;
  viewPackageLabel?: string;
  collapseLabel?: string;
  metaData: string;
  individualTiers: PlanType[];
  frequencies?: FrequenciesType[];
}
export default function PriceBlockV2CoursesClient({
  individualTiers,
  metaData,
}: PriceBlockCoursesProps) {
  return (
    <PriceBlockCoursesV2
      individualTiers={individualTiers}
      metaData={metaData || ''}  
      />
  );
}
